<section class="section">
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <h2 class="title font-weight-bold text-dark text-center">
          {{ 'landing.business' | translate }} {{ 'landing.directory' | translate }}
        </h2>
      </div>
    </div>

    @if (!isLoading) {
      <div class="row">
        @for (businessDirectory of businessDirectories; track businessDirectory; let i = $index) {
          <div class="col-lg-4 col-md-12 mb-3">
            <div class="box">
              <div class="img-panel mx-auto mb-2">
                <img
                  [src]="businessDirectory.companyLogoUrl || defaultLogo"
                  [alt]="businessDirectory.brandName"
                />
              </div>
              <div class="tw-mt-3">
                <app-tag-list [tags]="businessDirectory.sectors"></app-tag-list>
              </div>
              <div class="directory-text-panel">
                <div class="title line-clamp line-clamp-2">{{ businessDirectory.brandName }}</div>
                <div class="desc line-clamp line-clamp-2">{{ businessDirectory.tagline }}</div>
              </div>
              <div class="mt-auto">
                <a
                  class="btn btn-green btn-block"
                  [routerLink]="'/businesses/details/' + businessDirectory.slug"
                >
                  {{ 'common.viewDetails' | translate }}
                </a>
                @if (showNotify && businessDirectory.isSubscribed) {
                  <div
                    class="btn btn-blue d-flex justify-content-center mt-3"
                    (click)="
                      $event.stopPropagation(); $event.preventDefault(); notifyMe(businessDirectory)
                    "
                  >
                    <div class="pitchin-icon pitchin-icon-bell-icon-blue"></div>
                    <div class="text">{{ 'landing.notifyMe' | translate }}</div>
                  </div>
                }
                @if (showNotify && !businessDirectory.isSubscribed) {
                  <div
                    class="btn btn-lightgrey d-flex justify-content-center mt-3"
                    (click)="
                      $event.stopPropagation(); $event.preventDefault(); notifyMe(businessDirectory)
                    "
                  >
                    <div class="pitchin-icon pitchin-icon-notification"></div>
                    <div class="text">{{ 'landing.unsubscribed' | translate }}</div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (total > params.take) {
      <div class="row">
        <div class="col-lg-12">
          <div class="paging mt-3">
            <ngb-pagination
              [collectionSize]="total"
              [(pageSize)]="params.take"
              [(page)]="params.currentPage"
              (pageChange)="getList()"
              [maxSize]="5"
              [rotate]="true"
            >
              <ng-template ngbPaginationPrevious><i class="fa fa-chevron-left"></i></ng-template>
              <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
              <ng-template ngbPaginationNext><i class="fa fa-chevron-right"></i></ng-template>
            </ngb-pagination>
          </div>
        </div>
      </div>
    }
    @if (isLoading) {
      <agmo-loading></agmo-loading>
    }
  </div>
</section>
